import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import  Table  from 'antd/lib/table';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Badge, Dropdown, Space, Row, Col } from 'antd';

import AppService from './../../../../../service/app_service'
import AuthenticationService from './../../../../../service/authentication_service'
import UrlService from './../../../../../service/url_service'
import TopBarComponent from './../../../component/topbar_component'
import ModalComponent from './../../../component/modal_component'
import SockJsClient from 'react-stomp';

var interval = null;
var downloadTimer = null;

const GiveawayPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [showGiveawayModal, setShowGiveawayModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showActionModal, setShowActionModal] = useState(false);
    const [showImageOptions, setShowImageOptions] = useState(false);
    const [file, setFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);

    const [paymentSuccessful, setPaymentSuccessful] = useState(false);
    const [account, setAccount] = useState(null);
    const [amount, setAmount] = useState(0);
    const [giveawayAmount, setGiveawayAmount] = useState(0);
    const [giveawayQuantity, setGiveawayQuantity] = useState(0);
    const [giveawayUseDice, setGiveawayUseDice] = useState(0);
    const [giveawayDuration, setGiveawayDuration] = useState(0);
    const [giveawayRewardType, setGiveawayRewardType] = useState('airtime');
    const [giveawayGameType, setGiveawayGameType] = useState('fastestFinger');
    const [giveawayRewardPosition, setGiveawayRewardPosition] = useState('highest');
    const [allowMultipleWins, setAllowMultipleWins] = useState(1);
    const [isAdvert, setIsAdvert] = useState(0);
    const [isPublicAdvert, setIsPublicAdvert] = useState(0);
    const [countdownTime, setCountdownTime] = useState(null);
    const [missingAdvertDetail, setMissingAdvertDetail] = useState(false);
    const [captureAdvertInfo, setCaptureAdvertInfo] = useState(false);
    const [giveaways, setGiveaways] = useState([]);
    const [clientRef, setClientRef] = useState(null);
    const [orderRef, setOrderRef] = useState((new Date()).getTime().toString());

    const [channel, setChannel] = useState(null);
    const [email, setEmail] = useState(AuthenticationService.getEmail());
    const [name, setName] = useState(AuthenticationService.getName());
    const [phone, setPhone] = useState(AuthenticationService.getMobileNumber());
    const [publicKey, setPublicKey] = useState('pk_test_2372fc72b7cb8c49bab910c839370a2bbbc855b4');
    const [paystackAmount, setPaystackAmount] = useState(9000);

    
    const [selectedItem, setSelectedItem] = useState(null);
    const [switchGameType, setSwitchGameType] = useState(false);
    
    const [question, setQuestion] = useState(null);
    const [answer, setAnswer] = useState(null);
    const [includeUnit, setIncludeUnit] = useState(0);
    const [instruction, setInstruction] = useState(null);


    const [giveawayTemplate, setGiveawayTemplate] = useState(null);
    const [giveawayImage, setGiveawayImage] = useState(null);
    const [selectedGiveaway, setSelectedGiveaway] = useState(null);
    const [totalAmount, setTotalAmount] = useState(null);
    const [inputOpenFileRef, setInputOpenFileRef] = useState(React.createRef());


    //ads

    const [adsSponsorImage, setAdsSponsorImage] = useState(null);
    const [adsSponsorName, setAdsSponsorName] = useState(null);
    const [adsTitle, setAdsTitle] = useState(null);
    const [adsInformation, setAdsInformation] = useState(null);
    const [instructions, setInstructions] = useState(null);

    const [adsBackgroundImage, setAdsBackgroundImage] = useState(null);
    const [adsImages, setAdsImages] = useState([]);


    useEffect(() => {
        setChannel(channelGenerator());
        getTransactions(pageNumber);
        getGiveawayImageTemplates();
        //eslint-disable-next-line

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        if ('ALL' === props.match.params.orderRef) {
            AppService.getMyGiveaways(pageSize, pageNumber).then(rec => {
                setLoading(false)
                if (rec.error) {
                    // AuthenticationService.clearLocalstorage();
                    // this.props.history.push('/');
                } else {
                    setTransactions(rec.list)
                    if (rec && rec.list) {
                        //setTotalTransactionCount(rec.list.length);
                    }
                }
            })
        } else {
            AppService.getMyGiveawaysByRef(pageSize, pageNumber, props.match.params.orderRef).then(rec => {
                setLoading(false)
                if (rec.error) {
                    // AuthenticationService.clearLocalstorage();
                    // this.props.history.push('/');
                } else {
                    setTransactions(rec.list)
                    if (rec && rec.list) {
                        //setTotalTransactionCount(rec.list.length);
                    }
                }
            })
        }

    }

    const getGiveawayImageTemplates = () => {
        AppService.getGiveawayImageTemplates().then(rec => {
            setLoading(false)
            if (rec.error) {
                // AuthenticationService.clearLocalstorage();
                // this.props.history.push('/');
            } else {
                setGiveawayTemplate(JSON.parse(rec.data));
            }
        })
    }

    const generateGiveawayImage = (name, text) => {
        let data = {};
        data.documentName = name;
        data.content = text;
        // data.file = file;
        setLoading(true);
        AppService.generateGiveawayImage(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.description)
            } else {
                setGiveawayImage(rec);
            }
        })
    }

    const getAdvertDetailInfo = (input) => {
        let data = {};
        data.name = input.uid;
        // data.file = file;
        setLoading(true);
        AppService.getAdvertDetailInfo(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                setMissingAdvertDetail(true);
            } else {
                let result = JSON.parse(rec.data.content);
                setAdsBackgroundImage(result.adsBackgroundImage);
                setAdsImages(result.adsImages);
                setAdsInformation(result.adsInformation);
                setAdsSponsorImage(result.adsSponsorImage);
                setAdsSponsorName(result.adsSponsorName);
                setAdsTitle(result.adsTitle);
                setInstructions(result.instructions);
                setCaptureAdvertInfo(false);
                setMissingAdvertDetail(false);
            }
        })
    }


    const createAdvertDetailInfo = () => {
        let data = {};
        data.name = selectedItem.uid;

        let content = {};
        content.adsBackgroundImage = adsBackgroundImage;
        content.adsSponsorImage = adsSponsorImage;
        content.adsSponsorName = adsSponsorName;
        content.adsTitle = adsTitle;
        content.adsInformation = adsInformation;
        content.adsImages = adsImages;
        content.instructions = instructions;

        let contentString = JSON.stringify(content);
        data.content = contentString;
        // data.file = file;
        setLoading(true);
        if(missingAdvertDetail) {
            AppService.createAdvertDetailInfo(data).then(rec => {
                setLoading(false)
                if (rec.code != "200") {
                    message.error(rec.description)
                } else {
                    setMissingAdvertDetail(0);
                    message.success('Advert setup successful');
                    setCaptureAdvertInfo(false);
                }
            })
        }else {
            AppService.updateAdvertDetailInfo(data).then(rec => {
                setLoading(false)
                if (rec.code != "200") {
                    message.error(rec.description)
                } else {
                    setMissingAdvertDetail(0);
                    message.success('Advert setup successful');
                    setCaptureAdvertInfo(false);
                }
            })
        }
        
    }



    const copyImageToClipboard = async (imageURL) => {
        if (imageURL === undefined || imageURL === null) return;

        try {
            const image = await fetch(imageURL, {
                mode: 'no-cors'
            });
            const imageBlob = await image.blob();
            console.log(imageBlob);
            await navigator.clipboard
                .write([
                    new window.ClipboardItem({
                        [imageBlob.type]: imageBlob,
                    })
                ]);
            message.success("Image copied");
        } catch (error) {
            console.error(error);
        }
    }



    const changePage = (val) => {
        setPageNumber(val)
        getTransactions(val);
    }

    const paymentConfirmationCron = (ref) => {
        // navigator.serviceWorker.ready.then(registration => {
        //     interval = setInterval(() => {
        //         paymentConfirmation(false, ref);
        //         //registration.showNotification(title, options)
        //     }, 10000)
        // })
        interval = setInterval(() => {
            paymentConfirmation(false, ref);
        }, 10000)
    }

    const paymentConfirmation = (alerter, ref) => {
        setLoading(alerter);
        console.log("ref:",ref)
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.paymentConfirmation(data).then(rec => {

            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    //call back for order to be checked out
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                }
            } else {
                if(rec.description == 'Transaction has expired'){
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    message.error(rec.description);
                    setShowModal(false);
                }
                else if (alerter){
                    message.error(rec.description)
                }
                    
            }

        })

    }

    const payWithAccount = (ref) => {
        setLoading(true);
        let data = {};
        data.order = {};
        data.order.orderRef = ref;
        AppService.payWithAccount(data).then(rec => {
            setLoading(false);
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    setShowModal(false);
                    setChannel(channelGenerator());
                    getTransactions(pageNumber);
                }
            } else {
                message.error(rec.description);
            }

        })

    }

    const startCounter = (timeleft) => {
        downloadTimer = setInterval(function () {
            if (timeleft <= 4) {
                clearInterval(downloadTimer);
                if (document.getElementById("countdown") != null)
                    document.getElementById("countdown").innerHTML = "Time is up";
            } else {
                var minutes = Math.floor(timeleft / 60);
                var seconds = timeleft - (minutes * 60);
                var left = minutes + ":" + seconds;
                var element = document.getElementById("countdown");
                if (element)
                    element.innerHTML = left;

            }
            timeleft -= 1;
        }, 1000);
    }
    
    const makePayment = (debitMyAccount) => {
        //giveaway:qty_amount,qty_amount,qty_amount
        let arr = giveaways.map(item => (item.amount+'_'+ item.quantity+'_'+ item.gameType+'_'+ item.duration+'_'+ item.rewardType+'_'+ item.rewardPosition + '_'+ allowMultipleWins));
        let codedMessage = "giveaway:"+ arr.toString();
        console.log(codedMessage);
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.amount = amount;
        data.codedMessage = codedMessage;
        data.debitMyAccount = debitMyAccount;
        data.message = "GIVEAWAY";
        console.log("data:", data);
        clientRef.sendMessage('/app/make/payment', JSON.stringify(data));
        setLoading(true);
    };
    const config = {
        reference: orderRef,
        email: email,
        amount: paystackAmount,
        publicKey: publicKey,
        metadata: {
            name: name,
            phone: phone,
        }
    };


    const setAmountState = (amount) => {
        setAmount(amount);
        setPaystackAmount(100 * (amount + (200 + (1.5 * amount/100))));
    }

    const handleChange = (e) => {
        if(e.target.name === 'giveawayAmount'){
            setGiveawayAmount(e.target.value);
        }else if(e.target.name === 'giveawayQuantity'){
            setGiveawayQuantity(e.target.value);
        }else if(e.target.name === 'giveawayUseDice'){
            setGiveawayUseDice(e.target.value);
        }else if(e.target.name === 'giveawayDuration'){
            setGiveawayDuration(e.target.value);
        }else if(e.target.name === 'giveawayGameType'){
            setGiveawayGameType(e.target.value);
        }else if(e.target.name === 'giveawayRewardType'){
            setGiveawayRewardType(e.target.value);
        }else if(e.target.name === 'giveawayRewardPosition'){
            setGiveawayRewardPosition(e.target.value);
        } else if (e.target.name === 'imageUrl') {
            setImageUrl(e.target.value);
        }else if(e.target.name === 'allowMultipleWins'){
            setAllowMultipleWins(e.target.value);
        }else if(e.target.name === 'includeUnit'){
            setIncludeUnit(e.target.value);
        }else if(e.target.name === 'question'){
            setQuestion(e.target.value);
        }else if(e.target.name === 'answer'){
            setAnswer(e.target.value);
        }else if(e.target.name === 'instruction'){
            setInstruction(e.target.value);
        }else if(e.target.name === 'isAdvert'){
            console.log(e.target.value)
            setIsAdvert(e.target.value);
            if(e.target.value == 1){
                getAdvertDetailInfo(selectedItem);
            }
        }else if(e.target.name === 'isPublicAdvert'){
            setIsPublicAdvert(e.target.value);
        }else if(e.target.name === 'countdownTime'){
            setCountdownTime(e.target.value);
        }
        else if(e.target.name === 'adsSponsorName'){
            setAdsSponsorName(e.target.value);
        }
        else if(e.target.name === 'adsTitle'){
            setAdsTitle(e.target.value);
        }
        else if(e.target.name === 'adsInformation'){
            setAdsInformation(e.target.value);
        }else if(e.target.name === 'instructions'){
            setInstructions(e.target.value);
        }
        

    }

    
    const onChangeHandler = event => {

        let data = {
            upload: event.target.files[0]
        }
        setFile(null);
        setLoading(true);
        AppService.uploadonly(data)
            .then(response => {

                setLoading(false);
                if (response.code) {
                } else {
                    setFile(response.documentName); 
                    if(event.target.name === 'adsSponsorImage'){
                        setAdsSponsorImage(response.documentName)
                    }else if(event.target.name === 'adsBackgroundImage'){
                        setAdsBackgroundImage(response.documentName)
                    }else if(event.target.name === 'adsImages'){
                        let localadsImages = [response.documentName, ...adsImages];
                        setAdsImages(localadsImages)
                    }
                    
                }

            })
    }


    const addMoreGiveaway = () => {
        if(giveawayQuantity > 0 && giveawayAmount > 0){

            if("dice" === giveawayGameType &&  giveawayDuration < 1){
                alert("Missing dice game duration.")
            }else {
                let data = {};
                data.id =  channelGenerator();
                data.quantity = giveawayQuantity;
                data.amount = giveawayRewardType === 'cash' ? (parseInt(giveawayAmount) + 20) : parseInt(giveawayAmount);
                data.useDice = 0;
                data.duration = giveawayDuration;
                data.gameType = giveawayGameType;
                data.rewardType = giveawayRewardType;
                data.rewardPosition = giveawayRewardPosition;
                // data.useDice = giveawayUseDice;
                giveaways.push(data);
                
                setGiveawayAmount(0);
                setGiveawayQuantity(0);
                // setGiveawayUseDice(0);
                setGiveawayDuration(0);
                calculateTotal(giveaways);
            }
            
        }else {
            alert("Missing quantity or amount.");
        }
        
    };

    const removeGiveaway = (id) => {
        let result = giveaways.filter(function( obj ) {
            return obj.id !== id;
        });
        setGiveaways(result);
        calculateTotal(result);
    };

    const calculateTotal = (giveaways) => {
        let amt = giveaways.length > 0 ?giveaways.map(item => (item.amount * item.quantity)).reduce((prev, next) => prev + next) : 0;
        setAmountState(amt);
    }

    const channelGenerator = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
            return v.toString(16);
        });
    }

    const formatAmount = (amount) => {
        return amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }

    const closePaymentModal = () => {
        setShowModal(!showModal);
        clearInterval(interval);
        clearInterval(downloadTimer);
    }


    const openActionModal = (data, switchGameType) => {
        setSelectedItem(data);
        setSwitchGameType(switchGameType);
        setFile(data.questionImage);
        setQuestion(data.question);
        setAnswer(data.answer);
        setIncludeUnit(data.includeUnit);
        setInstruction(data.instruction);
        setIsAdvert(data.advert ? '1' : '0');
        setIsPublicAdvert(data.publicAdvert ? '1' : '0');
        setCountdownTime(data.countdownTime);
        if(switchGameType) {
            setGiveawayGameType(data.gameType);
            setGiveawayDuration(data.duration);
            setGiveawayRewardPosition(data.rewardPosition);
        }
        

        setShowActionModal(true);
        getAdvertDetailInfo(data);
    }


    const updateGiveaway = () => {
        let data = selectedItem;
        data.questionImage = file;
        data.question = question;
        data.answer = answer;
        data.includeUnit = includeUnit;
        data.instruction = instruction;
        data.advert = isAdvert == "1" ? true : false;
        data.publicAdvert = isPublicAdvert == "1" ? true : false;
        data.countdownTime = countdownTime;
        if(switchGameType) {
            data.gameType = giveawayGameType;
            data.duration = giveawayGameType === "dice" ? giveawayDuration : 0;
            data.rewardPosition = giveawayGameType === "dice" ? giveawayRewardPosition : "";
            data.diceVersion = giveawayGameType === "dice" ? true : false;
        }
        setLoading(true);
        AppService.updateGiveaway(data, switchGameType).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setFile(null);
                setQuestion(null);
                setAnswer(null);
                setIncludeUnit(0);
                setInstruction(null);
                setShowActionModal(false);
                message.success("Successful");
                getTransactions(pageNumber);
            }
        })
    }



    const items = [
        {
          key: '1',
          label: 'Action 1',
        },
        {
          key: '2',
          label: 'Action 2',
        },
      ];


    const expandedRowRender = () => {
        const columns = [
          {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
          },
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
          },
          {
            title: 'Status',
            key: 'state',
            render: () => (
              <span>
                <Badge status="success" />
                Finished
              </span>
            ),
          },
          {
            title: 'Upgrade Status',
            dataIndex: 'upgradeNum',
            key: 'upgradeNum',
          },
          {
            title: 'Action',
            dataIndex: 'operation',
            key: 'operation',
            render: () => (
              <Space size="middle">
                <a>Pause</a>
                <a>Stop</a>
                <Dropdown
                  menu={{
                    items,
                  }}
                >
                  <a>
                    More
                  </a>
                </Dropdown>
              </Space>
            ),
          },
        ];
        const data = [];
        for (let i = 0; i < 3; ++i) {
          data.push({
            key: i.toString(),
            date: '2014-12-24 23:12:00',
            name: 'This is production name',
            upgradeNum: 'Upgraded: 56',
          });
        }
        return <Table columns={columns} dataSource={data} pagination={false} />;
      };
      const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Platform',
          dataIndex: 'platform',
          key: 'platform',
        },
        {
          title: 'Version',
          dataIndex: 'version',
          key: 'version',
        },
        {
          title: 'Upgraded',
          dataIndex: 'upgradeNum',
          key: 'upgradeNum',
        },
        {
          title: 'Creator',
          dataIndex: 'creator',
          key: 'creator',
        },
        {
          title: 'Date',
          dataIndex: 'createdAt',
          key: 'createdAt',
        },
        {
          title: 'Action',
          key: 'operation',
          fixed: 'right',
          width: 100,
          render: () => <a>Publish</a>,
        },
      ];
      const data = [];
      for (let i = 0; i < 3; ++i) {
        data.push({
          key: i.toString(),
          name: 'Screem',
          platform: 'iOS',
          version: '10.3.4.5654',
          upgradeNum: 500,
          creator: 'Jack',
          createdAt: '2014-12-24 23:12:00',
        });
      }
    
    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3', minHeight: '700px' }} >
            <TopBarComponent />
            
            
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{ width: '100%' }}>
                                <h4 className="card-title">Giveaways Generated from Order : {props.match.params.orderRef}  <em className="text-primary ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getTransactions(pageNumber)} /></h4>
                                {/* <div style={{ float: 'right', margin: '10px 0px', width: 'auto' }}>
                                    <Link to="/giveaways" className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-arrow-left mr-3" />Back</Link>
                                    <Link to="/giveaways" className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-arrow-left" /></Link>
                                </div> */}
                                <div   style={{float: 'right', margin: '10px 0px', width: '100%'}}>
                                    <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Generate Giveaway</span></a>
                                </div>
                            </div>

                            <div className="content-area card" style={{ width: '100%' }}>
                                <div className="card-innr">
                                    <div className="card-head d-flex justify-content-between align-items-center">
                                        <h4 className="card-title mb-0"></h4>
                                        {/* <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Generate Giveaway</span></a>
                                         */}
                                    </div>
                                    <div className="card-head">
                                        <h4 className="card-title">What is giveaway?</h4>
                                    </div>
                                    <p>
                                        Giveaway is an act or instance of giving something away and with this platform,
                                        you can do a giveaway directly to the benefactors via airtime and any network of their choice,
                                        or via bank transfer to their bank account directly.
                                    </p>
                                    {'ALL' != props.match.params.orderRef && <a href={"/giveaway/detail/ALL"}><span className={"tnx-type-md badge badge-outline badge-success badge-md"} >View ALL</span><span className="tnx-type-sm badge badge-outline badge-success badge-md">View All</span></a>}

                                    {/* <button onClick={() => copyAllGiveawayLinks()} ><span className={"tnx-type-md badge badge-outline badge-success badge-md"} >Copy ALL Links</span></button> */}
                                </div>
                            </div>

                            
                            {/* <Row>
                <Col lg={12} md={12} sm={12}>
                {!loading && <Table
                                columns={columns}
                                expandable={{
                                expandedRowRender,
                                defaultExpandedRowKeys: ['0'],
                                }}
                                dataSource={data}
                            />}
                </Col>
            </Row> */}
                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer" style={{ paddingTop: '10px', marginTop: '40px' }}>
                                <div className="table-wrap">

                                    <Spin spinning={loading}>

                                        <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                            <thead>
                                                <tr className="data-item data-head" role="row">
                                                    <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Details</th>
                                                    <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Amount</th>
                                                    <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>Status</th>
                                                    {/* <th className="data-col dt-account sorting_disabled" rowSpan={1} colSpan={1}>Copy Link</th> */}
                                                    {/* <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                        <div className="dt-type-text">View</div>
                                                    </th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {transactions && transactions.length > 0 && transactions.map((item, i) => {
                                                    let amt = ("airtime" == item.rewardType) ? item.amount : (item.amount - item.withdrawalFee);
                                                    let link = item.gameType == "wordSearch" ? "https://ws.dogiveaway.com/?giveawayId=" + item.uid : "https://claim.dogiveaway.com/?giveawayId=" + item.uid;
                                                    if(item.gameType == "numberGame") {
                                                        link = "https://numbergame.dogiveaway.com/?giveawayId=" + item.uid;
                                                    }
                                                    if(item.advert) {
                                                        link = "https://public.dogiveaway.com/?giveawayId=" + item.uid;
                                                    }
                                                    return <tr className="data-item odd" role="row" key={i} style={{ background: item.givenToPhoneNumber ? 'lightgreen' : 'wheat' }}>
                                                        <td className="data-col dt-tnxno">
                                                            <div className="d-flex align-items-center">
                                                                <div style={{ marginRight: '15px', marginLeft: '5px' }}>{i + 1}</div>
                                                                {/* <div onClick={() => {if(item.givenAway) { navigator.clipboard.writeText(link); message.info('Giveaway Link Copied')} }} className={"data-state " + (item.givenAway ? 'data-state-approved' : 'data-state-progress')}>
                                                                    <span className="d-none">{item.status}</span>
                                                                </div> */}
                                                                {item.givenAway && <div className="fake-class" >
                                                                    <span className="lead tnx-id">{item.givenToPhoneNumber}</span>
                                                                    <span className="sub sub-date">{item.givenToNetwork}</span>
                                                                    <span className="sub sub-date"><a href={"/giveaway/detail/"+item.reference}><span>Ref : {item.reference}</span></a></span>
                                                                    <span className="sub sub-date">Date : {new Date(item.createdAt * 1000).toISOString().slice(0, 19).replace('T', ' ')}</span>
                                                                    {(item.gameType != 'quiz' || (item.gameType == 'quiz' && (item.question || item.questionImage))) && <a target="_blank" className={"btn btn-auto btn-xs btn-default"} style={{marginLeft: "5px", marginTop: '10px', color: "green", float: 'left', padding: '3px 3px 4px'}} href={link}>Open</a>} 
                                                                </div>}
                                                                {!item.givenAway && <div className="fake-class"  >
                                                                    <a className={"btn btn-auto btn-xs btn-default"} onClick={() => { setShowImageOptions(!showImageOptions); setSelectedGiveaway(item) }}>Generate Image</a>
                                                                   
                                                                    <span className="sub sub-date">
                                                                        <a href={"/giveaway/detail/"+item.reference}><span>Ref : {item.reference}</span></a>

                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" style={{marginLeft: '10px'}} onClick={() => openActionModal(item, true)} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shuffle"><polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line></svg>
                                                                    </span>
                                                                    {item.gameType == 'rockpaperscissors' &&<span className="sub sub-date">
                                                                        <a href={"https://rockpaperscissors.unifiedorbit.com/game/setup?giveawayId="+item.uid} target="_blank" >
                                                                            Open RPS Game Setup
                                                                            <span>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" style={{marginLeft: '10px'}} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-shuffle"><polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line></svg>
                                                                            </span>
                                                                        </a>
                                                                    </span>}
                                                                    <span className="sub sub-date">Date : {new Date(item.createdAt * 1000).toISOString().slice(0, 19).replace('T', ' ')}</span>
                                                                    {(item.gameType != 'quiz' || (item.gameType == 'quiz' && (item.question || item.questionImage))) &&  <a className={"btn btn-auto btn-xs btn-default"} style={{ marginLeft: '0px', marginTop: '10px', float: 'left', padding: '3px 3px 4px' }} onClick={() => { navigator.clipboard.writeText(link); message.info('Giveaway Link Copied to Clipboard') }} data-clipboard-text={link}>Copy Link</a>}
                                                                    {(item.gameType != 'quiz' || (item.gameType == 'quiz' && (item.question || item.questionImage))) && <a target="_blank" className={"btn btn-auto btn-xs btn-default"} style={{marginLeft: "5px", marginTop: '10px', color: "green", float: 'left', padding: '3px 3px 4px'}} href={link}>Open</a>} 
                                                            
                                                                </div>}
                                                            </div>
                                                        </td>

                                                        <td className="data-col dt-token">
                                                            <span className="lead token-amount">&#8358; {parseFloat(amt).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                                            <span className="sub sub-symbol"></span>
                                                            <span className="lead token-amount">{item.gameType} </span>
                                                            {item.diceVersion && <span className="sub sub-symbol">({item.duration + ' mins'}) </span>}
                                                            
                                                            {item.gameType == 'quiz' && <a className={"btn btn-auto btn-xs btn-default"} style={{marginTop: "10px", color: "brown", padding: '3px 3px 4px'}} onClick={() => openActionModal(item, false)}>{(item.question || item.questionImage) ? 'Update Q & A' : 'Setup Q & A'}</a>}
                                                        </td>

                                                        <td className="data-col dt-usd-amount">
                                                            <span className="lead amount-pay">{item.givenToPhoneNumber ? 'REDEEMED' : 'PENDING'}</span>
                                                            <span className="sub sub-symbol">Reward Type: {item.rewardType}</span>
                                                            <span className="sub sub-symbol">Reward Position: {item.rewardPosition}</span>
                                                            {item.publicAdvert && <span className="sub sub-symbol" style={{color: 'black'}}>{item.publicAdvert ? 'Public Advert' :  ''}</span>}
                                                            {(item.advert && !item.publicAdvert) && <span className="sub sub-symbol" style={{color: 'black'}}>{item.advert ? 'Private Advert' :  ''}</span>}

                                                           
                                                        </td>
                                                        {/* <td className="data-col dt-account">{(item.gameType != 'quiz' || (item.gameType == 'quiz' && (item.question || item.questionImage))) && <button onClick={() => { navigator.clipboard.writeText(link); message.info(' Copied to Clipboard') }} className="copy-triggers copy-clipboard" data-clipboard-text={link}><em className="ti ti-files" /></button>}</td> */}
                                                        {/* <td className="tnx-type">{(item.gameType != 'quiz' || (item.gameType == 'quiz' && (item.question || item.questionImage))) && <a target="_blank" href={link}>Open</a>} </td> */}

                                                    </tr>
                                                })}

                                                {transactions && transactions.length > 0 && <tr>
                                                    <Pagination onChange={changePage} pageSize={pageSize} defaultCurrent={pageNumber} current={pageNumber} total={totalTransactionCount} />
                                                </tr>}
                                            </tbody>
                                        </table>
                                    </Spin>
                                </div>
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>


            {showImageOptions && <ModalComponent show={showImageOptions} closeModal={() => { setShowImageOptions(!showImageOptions); setGiveawayImage(null); }} title="Giveaway Image Template" >
                <Spin spinning={loading}>
                    <div>

                        <div className="row" style={{ maxHeight: '80vh', overflowY: 'scroll' }}>
                            {!giveawayImage && <div className="col-sm-6">
                                <h6 style={{ paddingTop: '20px' }}>My Custom Image</h6>
                                {file && <img src={'https://tradexsafely.com/xchange/attachments/'+file} />}
                                <br />
                                {!file && <p>Upload your own template</p>}
                                <input type="file" id="file" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                {file && <button onClick={() => generateGiveawayImage(file, "https://claim.dogiveaway.com/?giveawayId=" + selectedGiveaway.uid)} className="btn btn-sm btn-success">Use This</button>}
                            </div>}
                            {!giveawayImage && <div className="col-sm-6">
                                <h6 style={{ paddingTop: '20px' }}>My Image URL</h6>
                                <br />
                                <input type="text" name="imageUrl" className="input-bordered"  style={{ display: "block" }} onChange={handleChange} />
                                {imageUrl && <button onClick={() => generateGiveawayImage(imageUrl, "https://claim.dogiveaway.com/?giveawayId=" + selectedGiveaway.uid)} className="btn btn-sm btn-success">Use This</button>}
                            </div>}
                            {
                                !giveawayImage && giveawayTemplate && giveawayTemplate.map((item, i) => {
                                    return <div className="col-sm-6" key={i}>
                                        <h6 style={{ paddingTop: '20px' }}>{item.name} </h6>
                                        <img src={item.demo} />
                                        <br />
                                        <button onClick={() => generateGiveawayImage(item.file, "https://claim.dogiveaway.com/?giveawayId=" + selectedGiveaway.uid)} className="btn btn-sm btn-success">Use This Template</button>
                                    </div>
                                })
                            }
                            {
                                giveawayImage && <div className="col-sm-12" >
                                    <h6 style={{ paddingTop: '20px' }}>Generated Image with giveaway Qrcode </h6>
                                    <a className={"btn btn-auto btn-xs btn-default"} style={{ marginLeft: '5px' }} onClick={() => { navigator.clipboard.writeText("https://claim.dogiveaway.com/?giveawayId=" + selectedGiveaway.uid); message.info(' Copied to Clipboard') }} data-clipboard-text={"https://claim.dogiveaway.com/?giveawayId=" + selectedGiveaway.uid}>Copy Link</a>

                                    <img src={giveawayImage.description} />
                                    <br />
                                    <button onClick={() => setGiveawayImage(null)} className="btn btn-sm btn-primary">Close</button>
                                </div>
                            }
                        </div>
                    </div>
                </Spin>
            </ModalComponent>}


            {showModal && <ModalComponent show={showModal} closeModal={() => closePaymentModal()} title="Make payment" >
                    <Spin spinning={loading}>
                    <div>

                        {!paymentSuccessful && <div>
                            <p>Please make a bank transfer to the account detail below.</p>
                            <div className="gaps-1x" />
                            {/* <h6 className="font-bold">Payment to the following bank detail</h6> */}
                            <div className="row">
                                <div className="col-sm-4">
                                    <h6 style={{paddingTop: '20px'}}>Account Number</h6>
                                </div>
                                <div className="col-sm-8">
                                    <div className="copy-wrap mgb-0-5x" style={{fontSize: '20px', fontWeight: 400}}>
                                        <span className="copy-feedback" style={{ display: 'none' }}>Copied to Clipboard</span>
                                        <em className="fab fa-account" />
                                        <input type="text" className="copy-address" style={{padding: '12px 30px 12px 20px'}} defaultValue={account && account.accountNumber} disabled />
                                        <button onClick={() => { navigator.clipboard.writeText(account && account.accountNumber); message.info(' Copied to Clipboard') }} className="copy-trigger copy-clipboard" data-clipboard-text={account && account.accountNumber}><em className="ti ti-files" /></button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* .copy-wrap */}
                            <ul className="pay-info-list row">
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Bank:</span> <strong>{account && account.bank}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Account Name:</span> <strong>{account && account.accountName}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Amount:</span> <strong style={{fontSize: '18px'}}>&#8358; {account && account.totalAmount && account.totalAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong></li>
                            </ul>
                            
                            <div style={{fontSize: '16px', color: 'red'}}>You have to make payment in the next <h5 id="countdown"></h5></div>
                            
                            <div className="note note-plane note-light mgb-1x" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Do not make payment to another account.  </p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Send the exact amount stated above. Nothing more, nothing less</p>
                            </div>
                            <div className="note note-plane note-light" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p><strong>For any payment or giveaway issues, call or send whatsapp to +2348060765123 for immediate support.</strong> </p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p>You can also pay with your funded account by clicking on <strong> Pay With My Account</strong></p>
                            </div>
                            <div className="gaps-3x" />
                            <button className="btn btn-primary" style={{float: 'right'}} onClick={() => paymentConfirmation(true, orderRef)} >Confirm Payment  <em className="ti ti-arrow-right mgl-4-5x" /></button>
                            
                            <button className="btn btn-success" style={{float: 'right', marginRight: '8px'}} onClick={() => payWithAccount(orderRef)} >Pay With My Account<em className="ti ti-arrow-right mgl-4-5x" /></button>


                            
                            
                        </div>}

                        {paymentSuccessful && <div className="status status-thank px-md-5">
                            <div className="status-icon"><em className="ti ti-check" /></div>
                            <span className="status-text large text-dark">Thank you for submitting form</span>
                            <p className="px-md-5">We received your data, our team will check and get back you via email.</p>
                        </div>}
                    </div>
                    </Spin>
                </ModalComponent>}

                {showGiveawayModal && <ModalComponent show={setShowGiveawayModal} closeModal={() => setShowGiveawayModal(false)} title="Generate Giveaway" >
                    <div  >
                        <Spin spinning={loading}>
                            <div className="row scroll-modal" style={{overflow: 'scroll',overflowY: 'scroll',maxHeight: '500px'}} >
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount Per Giveaway</label>
                                        <input type="number" name="giveawayAmount" value={giveawayAmount} className="input-bordered" placeholder="Amount Per Giveaway" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">How many giveaway</label>
                                        <input type="number" name="giveawayQuantity" value={giveawayQuantity} className="input-bordered" placeholder="How many giveaway" onChange={handleChange} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Game Type</label>
                                        <select className="input-bordered" name="giveawayGameType" id="giveawayGameType" onChange={handleChange} >
                                            <option value="fastestFinger">Fastest Finger</option>
                                            <option value="dice">Roll Dice</option>
                                            <option value="wordSearch">Word Search Game</option>
                                            <option value="numberGame">Number Puzzle Game</option>
                                            <option value="quiz">Quiz</option>
                                            <option value="rockpaperscissors">Rock Paper Scissors</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Reward Channel</label>
                                        <select className="input-bordered" name="giveawayRewardType" id="giveawayRewardType" onChange={handleChange} >
                                            <option value="airtime">Airtime</option>
                                            <option value="cash">Cash</option>
                                        </select>
                                    </div>
                                </div>
                                {giveawayGameType === 'dice' && <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Dice Game duration (minutes)</label>
                                        <input type="number" name="giveawayDuration" value={giveawayDuration} className="input-bordered" placeholder="Dice Game duration" onChange={handleChange} />
                                    </div>
                                </div>}
                                {giveawayGameType === 'dice' &&  <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="nationality" className="input-item-label">Giveaway Reward Position</label>
                                        <select className="input-bordered" name="giveawayRewardPosition" id="giveawayRewardPosition" onChange={handleChange} >
                                            <option value="highest">Highest</option>
                                            <option value="lowest">Lowest</option>
                                        </select>
                                    </div>
                                </div>}
                                <div className="col-md-12">
                                    <button className="btn btn-primary" style={{float: 'right'}} onClick={() => addMoreGiveaway()} >Add</button>
                                </div>
                                <div className="col-md-12" style={{marginTop: '5px'}}>
                                    {giveawayRewardType === 'airtime' &&<h6 className="kyc-alert text-danger">* Note that each airtime reward giveaway requires no additional fees</h6>}
                                    {giveawayRewardType === 'cash' &&<h6 className="kyc-alert text-danger">* Note that each cash reward giveaway requires additional &#8358; 20.00 for each bank transfer to beneficiaries</h6>}
                                    
                                </div>

                                <div className="col-md-12" style={{marginTop: '10px'}}>
                                    <div className="row">
                                        { giveaways && giveaways.length > 0 && giveaways.map((item, i) => {
                                            let hint = "";
                                            if(item.rewardType === 'airtime'){
                                                hint = hint + "Note : participants will be rewarded with airtime.";
                                            }else {
                                                hint = hint + "Note : participants will be rewarded with cash.";
                                            }

                                            if(item.gameType === 'fastestFinger'){
                                                hint = hint + "And the giveaway will be won by beneficiary with fastest finger.";
                                            }else {
                                                hint = hint + "And the giveaway will be won by beneficiary with first "+item.rewardPosition+" dice value.";
                                            }
                                            return <div className="col-md-6" key={i} style={{boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px', paddingRight: '5px'}} >
                                                <div className="kyc-info card">
                                                    <div className="card-innr">
                                                        <div className="-">Amount Per Giveaway : <strong>&#8358; {formatAmount(item.amount)}</strong> </div>
                                                        <div className="">No of Giveaway           : <strong>{item.quantity}</strong> </div>
                                                        <div className="">Game Type              : <strong>{item.gameType}</strong> </div>
                                                        <div className="">Reward Channel       : <strong>{item.rewardType}</strong> </div>
                                                        <div className="">Reward Position       : <strong>{item.rewardPosition}</strong> </div>
                                                        <div className="">Amount       : <strong>&#8358; {formatAmount(item.amount * item.quantity)}</strong> </div>
                                                        <div className="">Delete       : <i className="fas fa-trash" onClick={() => removeGiveaway(item.id)} /></div>
                                                        <h6 className="kyc-alert text-danger">* {hint}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                                {giveaways && giveaways.length > 0 &&  <div className="col-md-12">
                                    <div className="input-item input-with-label">
                                        <label htmlFor="allowMultipleWins" className="input-item-label">Allow Multiple Wins</label>
                                        <select className="input-bordered" name="allowMultipleWins" id="allowMultipleWins" onChange={handleChange} >
                                            <option value={1}>Yes</option>
                                            <option value={0}>No</option>
                                        </select>
                                    </div>
                                    <h6>* Allowing multiple wins means that same person can win multiple times in this giveaway batch.</h6>
                                </div>}
                                <div className="col-md-12" style={{marginTop: '30px'}}>
                                    <h5>Giveaway Amount : {formatAmount(amount)}</h5>
                                </div>

                                

                                <hr />
                                <br />
                                <br />
                                <br />
                                

                                {giveaways && giveaways.length > 0 && <div className="col-md-12">
                                    {false && <h6>Pay by bank transfer : Fee = &#8358; 100</h6>}
                                    {false && <h6>If you Pay by bank transfer,  Amount + Fee = &#8358; {formatAmount(100 + amount)}</h6>}
                                    {false && <Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={() => makePayment(false)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" style={{float: 'right', marginRight: '8px'}} disabled={loading} name="submit" className="btn btn-success">Bank Transfer (&#8358; {formatAmount(100 + amount)})</button>
                                    </Popconfirm>}
                                    {<Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={() => makePayment(true)}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success">Generate Giveaway</button>
                                    </Popconfirm>}
                                </div>}
                                
                                {/* {giveaways && giveaways.length > 0 && <div className="col-md-6">
                                    <h6>Pay with card : Fee = &#8358; {formatAmount(200 + (1.5*amount/100))}</h6>
                                    <h6>Amount + Fee = &#8358; {formatAmount((200 + (1.5*amount/100)) + amount)}</h6>
                                    {<PaystackButton {...componentProps} className="btn btn-success btn-block" />}
                                </div>} */}

                            </div>
                        </Spin>




                    </div>

                    


                    </ModalComponent>}

                    {showActionModal && <ModalComponent show={setShowActionModal} closeModal={() => setShowActionModal(false)} title={switchGameType ? "Change Game Type" :"Manage Question"} >
                        <div>
                            <div className="row scroll-modal" style={{overflow: 'scroll',overflowY: 'scroll',maxHeight: '500px'}} >
                                
                                {switchGameType && <>
                                    <div className="col-md-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Game Type</label>
                                            <select className="input-bordered" name="giveawayGameType" id="giveawayGameType" value={giveawayGameType} onChange={handleChange} >
                                                <option value="fastestFinger">Fastest Finger</option>
                                                <option value="dice">Roll Dice</option>
                                                <option value="wordSearch">Word Search Game</option>
                                                <option value="numberGame">Number Puzzle Game</option>
                                                <option value="quiz">Quiz</option>
                                                <option value="rockpaperscissors">Rock Paper Scissors</option>
                                            </select>
                                        </div>
                                    </div>
                                    {giveawayGameType === 'dice' && <div className="col-md-6">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Dice Game duration (minutes)</label>
                                            <input type="number" name="giveawayDuration" value={giveawayDuration} className="input-bordered" placeholder="Dice Game duration" onChange={handleChange} />
                                        </div>
                                    </div>}
                                    {giveawayGameType === 'dice' &&  <div className="col-md-6">
                                        <div className="input-item input-with-label">
                                            <label htmlFor="nationality" className="input-item-label">Giveaway Reward Position</label>
                                            <select className="input-bordered" name="giveawayRewardPosition" id="giveawayRewardPosition" onChange={handleChange} >
                                                <option value="highest">Highest</option>
                                                <option value="lowest">Lowest</option>
                                            </select>
                                        </div>
                                    </div>}

                                    {name === "Iyke Perry" && <div className="col-md-6">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Is this for advert? {name}</label>
                                            <select className="input-bordered" name="isAdvert" id="isAdvert" value={isAdvert} onChange={handleChange} >
                                                <option value={0}>No</option>
                                                <option value={1}>Yes</option>
                                            </select>
                                        </div>
                                    </div>}

                                    {isAdvert == 1 && <div className="col-md-6">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Is this a public advert?</label>
                                            <select className="input-bordered" name="isPublicAdvert" id="isPublicAdvert" value={isPublicAdvert} onChange={handleChange} >
                                                <option value={0}>No</option>
                                                <option value={1}>Yes</option>
                                            </select>
                                        </div>
                                    </div>}

                                    {isAdvert == 1 && <div className="col-md-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Countdown Time</label>
                                            <input type="datetime-local" name="countdownTime" value={countdownTime} className="input-bordered" placeholder="Dice Game duration" onChange={handleChange} />
                                        </div>
                                    </div>}
                                    <div className="col-md-12">
                                    {name === 'Iyke Perry' && missingAdvertDetail && <p style={{color: 'red'}}>Missing Advert Information : <a style={{color: 'black'}} onClick={() => {setCaptureAdvertInfo(true)}}>click here</a>  to set it up</p>}
                                    {isAdvert && !missingAdvertDetail && <p style={{color: 'green'}}>To View Advert Information : <a style={{color: 'black'}} onClick={() => {setCaptureAdvertInfo(true)}}>click here</a></p>}
                                    </div>

                                    {((isAdvert == 1 && !missingAdvertDetail) || (isAdvert != 1)) && !captureAdvertInfo && <div className="col-md-12">
                                        <button className="btn btn-primary" style={{float: 'right'}} onClick={() => updateGiveaway()} >Submit</button>
                                    </div>}




                                    {captureAdvertInfo && <>
                                        <div className="col-sm-6">
                                            <h6 style={{ paddingTop: '20px' }}>Ads Sponsor Image/Logo</h6>
                                            {adsSponsorImage && <img src={'https://tradexsafely.com/xchange/attachments/'+adsSponsorImage} width={100} />}
                                            <br />
                                            {!adsSponsorImage && <p>Upload Ads Sponsor Image</p>}
                                            {adsSponsorImage && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" onClick={() => setAdsSponsorImage(null)} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>}
                                            <input type="file" id="file" name="adsSponsorImage" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                        </div>
                                        <div className="col-sm-6">
                                            <h6 style={{ paddingTop: '20px' }}>Ads Background Image</h6>
                                            {adsBackgroundImage && <img src={'https://tradexsafely.com/xchange/attachments/'+adsBackgroundImage} width={100} />}
                                            <br />
                                            {!adsBackgroundImage && <p>Upload Ads Background Image</p>}
                                            {adsBackgroundImage && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" onClick={() => setAdsBackgroundImage(null)} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>}
                                            <input type="file" id="file" name="adsBackgroundImage" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                        </div>
                                        


                                        <div className="col-md-12">
                                            <div className="input-item input-with-label">
                                                <label className="input-item-label">Name of Ads Sponsor</label>
                                                <input type="text" name="adsSponsorName" value={adsSponsorName}  className="input-bordered" placeholder="Who is sponsoring this advert?" onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="input-item input-with-label">
                                                <label className="input-item-label">Ads Title</label>
                                                <input type="text" name="adsTitle" value={adsTitle}  className="input-bordered" placeholder="Title of advert?" onChange={handleChange} />
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="input-item input-with-label">
                                                <label className="input-item-label">Ads Information</label>
                                                <br />
                                                <textarea  name="adsInformation" value={adsInformation}  cols="50" rows="5"  onChange={handleChange}>
                                                </textarea>
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            <div className="input-item input-with-label">
                                                <label className="input-item-label">Instructions</label>
                                                <br />
                                                <textarea  name="instructions" value={instructions}  cols="50" rows="5"  onChange={handleChange}>
                                                </textarea>
                                            </div>
                                        </div>

                                        <div className="col-sm-12">
                                            <h6 style={{ paddingTop: '20px' }}>Ads Images</h6>
                                            <br />
                                            {adsImages.length == 0 && <p>Upload Ads Image</p>}
                                            <input type="file" id="adsImages" name="adsImages" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                        </div>

                                         {
                                            adsImages && adsImages.length > 0 && adsImages.map((item, i) => {
                                                return <div style={{margin: '10px 10px'}}> 
                                                        <img src={'https://tradexsafely.com/xchange/attachments/'+item} width={100} /> 

                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" onClick={() => {
                                                            let arr = adsImages.filter(function(adsImage) {
                                                                return adsImage !== item
                                                            })
                                                            setAdsImages(arr)
                                                        }}   viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>
                                                        <br /> 
                                                    </div>;
                                            })
                                         }

                                        <div className="col-md-12" style={{marginTop: '15px'}}>
                                            <button className="btn btn-danger" style={{float: 'left'}} onClick={() => {setCaptureAdvertInfo(false)}} >Close</button>
                                            <button className="btn btn-success" style={{float: 'right'}} onClick={() => createAdvertDetailInfo()} >Publish</button>
                                        </div>
                                        
                                        

                                    </>}
                                </>}
                                {!switchGameType && <>
                                    {<div className="col-sm-12">
                                        <h6 style={{ paddingTop: '20px' }}>Question Image</h6>
                                        {file && <img src={'https://tradexsafely.com/xchange/attachments/'+file} />}
                                        <br />
                                        {!file && <p>Upload Question Image</p>}
                                        {file && <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" onClick={() => setFile(null)} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>}
                                        <input type="file" id="file" ref={inputOpenFileRef} style={{ display: "block" }} onChange={onChangeHandler} />
                                    </div>}
                                        
                                    <div className="col-sm-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Question</label>
                                            <br />
                                            <textarea  name="question" value={question}  cols="50" rows="5"  onChange={handleChange}>

                                            </textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Answer</label>
                                            <input type="text" name="answer" value={answer}  className="input-bordered" placeholder="Answer to Question" onChange={handleChange} />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Include unit in answer</label>
                                            <select className="input-bordered" name="includeUnit" id="includeUnit" value={includeUnit}  onChange={handleChange} >
                                                
                                                <option value={0}>No</option>
                                                <option value={1}>Yes</option>
                                            </select>
                                        <h6>* indicate if answer includes unit of measurement.</h6>
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="input-item input-with-label">
                                            <label className="input-item-label">Instruction</label>
                                            <input type="text" name="instruction" value={instruction}  className="input-bordered" placeholder="Any instruction" onChange={handleChange} />
                                        </div>
                                    </div>
                                    
                                    

                                    <div className="col-md-12">
                                        <button className="btn btn-primary" style={{float: 'right'}} onClick={() => updateGiveaway()} >Submit</button>
                                    </div>
                                </>}
                                

                            </div>
                        </div>
                    </ModalComponent>}

                {<SockJsClient url={UrlService.BASE_PATH + '/unified/'}
                    topics={['/queue/chat/' + channel]}
                    onConnect={() => {
                        console.log("connected");
                        let data = {};
                        data.channel = channel;
                    }}
                    onDisconnect={() => {
                        console.log("Disconnected");
                    }}
                    onMessage={(msg) => {
                        console.log("mssg", msg)
                        if (msg.action === "MAKE_PAYMENT") {
                            setShowGiveawayModal(false);
                            setAccount(msg.account);
                            setAmountState(msg.order.totalAmount);
                            setOrderRef(msg.order.orderRef);
                            setShowModal(true);
                            setLoading(false);
                            startCounter(msg.timeFrame * 60);
                            paymentConfirmationCron(msg.order.orderRef);
                        }else if (msg.action === 'SUCCESS') {
                            message.success(msg.message);
                            setShowGiveawayModal(false);
                            setLoading(false);
                            getTransactions(pageNumber);
                        } else if (msg.action === "ERROR") {
                            setShowGiveawayModal(false);
                            setLoading(false);
                            message.error(msg.message);
                            getTransactions(pageNumber);
                        }
                    }}
                    ref={(client) => {
                        setClientRef(client);
                    }} />}



        </div>
    );

}

export default withRouter(GiveawayPage);
